import TYPES from '../../types';

// Domain
import { OriginEntity } from '../../domain/entities/origin-entity';
import { OriginRepository } from '../../domain/repository/origin-repository';
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class SearchOriginsQuery extends Query<Promise<Array<OriginEntity>>> {
  @Inject(TYPES.CATALOG_KUSPIT_ORIGIN_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.CATALOG_KUSPIT_ORIGIN_REPOSITORY)
  private readonly repository!: OriginRepository;

  internalExecute(): Promise<Array<OriginEntity>> {
    return new Promise((resolve, reject) => {
      if (!this.state_manager.state.loaded) {
        this.repository.execute()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      } else {
        resolve(this.state_manager.state.items);
      }
    });
  }
}
